import { useSearchParams } from 'next/navigation';
import getProductLabelOverride, { getLabelPreviewTime } from '@/commons/getProductLabelOverride';
const useProductLabelOverride = productId => {
  const labelDate = useSearchParams()?.get("labelDate");
  return getProductLabelOverride(productId, getLabelPreviewTime(labelDate));
};
export default useProductLabelOverride;